export enum AccommodationPriceType {
  PerNight = "PerNight",
  PerWeek = "PerWeek",
  PerMonth = "PerMonth"
}
